<template>
  <div class="subscription-mutate" v-if="data">
    <div class="container view">
      <div class="subscription-mutate__wrapper">
        <Card tag="form" @submit.prevent="submit" class="subscription-mutate__form">
          <template #header>
            <h1>Rediger "{{ $t(`addon:${data.item}`) }}" abonnement for {{ $path('metadata.source.name', data) }}</h1>
            <p v-if="error">{{ $t('somethingWentWrong') }}</p>
          </template>

          <template #default>
            <InputComponent :label="$t('startDate')">
              <template #default>
                <InputDate v-model="data.start" />
              </template>
            </InputComponent>

            <InputComponent :label="$t('endDate')">
              <template #default>
                <InputDate v-model="data.end" />
              </template>
            </InputComponent>

            <InputComponent
              :label="$t('lockInPeriod')"
              :sublabel="$t('lockInPeriodX', { x: $tc('month', 0).toLowerCase() })"
              :value="lockComp"
              @input="$ev => (lockComp = $ev)"
              suffix="M"
              :mask="{
                mask: Number,
                unmask: true,
                scale: 0,
              }"
            >
            </InputComponent>
            <InputComponent
              :label="$t('noticePeriod')"
              :sublabel="$t('lockInPeriodX', { x: $tc('month', 0).toLowerCase() })"
              suffix="M"
              v-model="noticeComp"
              :mask="{
                mask: Number,
                unmask: true,
                scale: 0,
              }"
            >
            </InputComponent>

            <hr style="grid-column: 1 / -1; width: 100%; border-color: var(--border-color)" />

            <template v-for="(price, index) in data.price"  >
              <InputComponent :label="$t('price')" suffix="Kr" v-model="price.value" type="number" :key="index"/>

              <InputComponent :label="$tc('type', 1)">
                <Select
                  :items="[
                    { label: $t('fixedPrice'), value: 'fixed' },
                    { label: $t('monthlyPrice'), value: 'monthly' },
                    { label: $t('establishmentPrice'), value: 'establishment' },
                  ]"
                  v-model="price.type"
                />
              </InputComponent>
            </template>
            <div class="subscription-mutate__price-actions" style="grid-column: 1 / -1">
              <ButtonComponent @click="addPrice" :label="$t('add')" ></ButtonComponent>
              <ButtonComponent
                @click="removePrice()"
                :disabled="data.price.length === 1"
                :label="`${$t('delete')}`"
              ></ButtonComponent>
            </div>
          </template>

          <template #footer>
            <ButtonComponent v-if="redirectUrl" :label="$t('goBack')" @click="redirect" />

            <ButtonComponent
              :disabled="isDisabled"
              type="submit"
              :label="$t('update')"
              :promise="promise"
              :icon="['fal', 'arrow-to-right']"
              theme="primary"
            />
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from '@/components/Card'
import InputDate from '@/components/InputDate'
import { InputComponent } from 'vue-elder-input'
import Select from '@/components/Select/Select'
import { Clone } from '@/utils'

function parsePeriod(period) {
  return { value: period.substr(0, period.length - 1), unit: period.substr(-1) }
}

export default {
  props: {
    id: String,
  },

  data() {
    return {
      promise: null,
      error: null,
      data: null,
    }
  },
  computed: {
    lockComp: {
      get() {
        return parsePeriod(this.data.lockInPeriod).value
      },
      set(val) {
        this.data.lockInPeriod = val ? val + 'M' : val
      },
    },

    noticeComp: {
      get() {
        return parsePeriod(this.data.noticePeriod).value
      },
      set(val) {
        this.data.noticePeriod = val ? val + 'M' : val
      },
    },
    isDisabled() {
      return this.error || !Boolean(this.data.start)
    },

    redirectUrl() {
      return this.$route.query.redirect
    },
  },
  methods: {
    addPrice() {
      this.data.price.push(
        Clone({
          // keep unit conditions
          ...this.data.price[0],
          value: 0,
        }),
      )
    },

    redirect() {
      const url = new URL(this.redirectUrl)

      if (url.hostname === window.location.hostname) return this.$router.push(url.pathname)

      return (window.location.href = url)
    },

    removePrice() {
      this.data.price.pop()
    },

    submit() {
      if (this.isDisabled) return

      this.promise = fetch(`/api/subscription/${this.id}/update`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.data),
      })
    },
  },
  created() {
    this.promise = fetch(`/api/subscription/${this.id}`)
      .then(res => res.json())
      .then(data => {
        if (!data.lockInPeriod) data.lockInPeriod = ''
        if (!data.noticePeriod) data.noticePeriod = ''

        this.data = data
      })
      .catch(err => {
        this.error = true
        console.error(err)
      })
  },
  metaInfo() {
    return {
      title: 'Rediger abonnement',
    }
  },
  components: {
    Card,
    InputDate,
    InputComponent,
    Select,
  },
}
</script>

<style lang="scss">
.subscription-mutate {
  background-color: $background-grey;

  h1 {
    margin: 0;
  }

  &__wrapper {
    max-width: 600px;
    margin: 0 auto;
  }

  &__price {
    &-actions {
      display: flex;
      gap: 0.5rem;
      justify-content: end;
    }
  }

  &__form {
    .card__header {
      text-align: center;
    }

    .card__content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
    }

    .card__footer-content {
      // justify-content: end;
    }
  }
}
</style>
